import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledPoint} from '@/features/projects/components/progress-status-badge/style'
import {ProjectProgressStatus} from '@/features/projects/types'
import {projectProgressStatusToIcon, projectProgressStatusToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'

export const ProgressStatusBadge = ({progressStatus}: {progressStatus: ProjectProgressStatus}) => {
    const {t} = useTranslation()

    // Terminal states have nothing actionable to surface: opening transmitted (project still open,
    // waiting for closure) and fully transmitted (closing transmitted).
    if (progressStatus === 'transmitted_opening' || progressStatus === 'transmitted_closing') return null

    const Icon = projectProgressStatusToIcon[progressStatus]

    const description: Record<Exclude<ProjectProgressStatus, 'transmitted_opening' | 'transmitted_closing'>, string> = {
        incomplete: t('projects:verify_missing_data'),
        to_print: t('projects:projects_siar'),
        to_export_opening: t('projects:siar_opening'),
        to_transmit_opening: t('projects:siar_opening'),
        to_export_closing: t('projects:siar_closing_project'),
        to_transmit_closing: t('projects:siar_closing_project')
    }

    return (
        <Flexbox gap={2} align="center">
            <Badge variant={progressStatus === 'incomplete' ? 'orange' : 'neutral'} size="sm" shape="roundedRectangle">
                <Icon />
                {t(projectProgressStatusToLabel[progressStatus])}
            </Badge>
            <Flexbox align="center" justify="center" gap={1}>
                <StyledPoint />
                <Text size="textSm" palette="neutral" shade="600">
                    {description[progressStatus]}
                </Text>
            </Flexbox>
        </Flexbox>
    )
}
